import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps, SimpleGrid } from '@mantine/core'

import { Container } from 'components/atoms/container'
import { useMyHealth } from 'hooks/useMyHealth'
import { HEALTH_TOOL_NAME } from 'interfaces/constants/healthTools'
import { HealthTool } from 'interfaces/types'

import useStyles from './index.styles'
import { ToolCard } from './toolCard'
import { DISLAY_TOOL } from '..'
import { useAppContext } from 'hooks/useAppContext'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useIsMobile } from 'hooks/useIsMobile'
import { CarouselOrListingBlock } from 'components/molecules/carouselOrListingBlock'

type Props = {
  healthools: HealthTool[]
} & BoxProps

const MAPPING_KEY_RESPONSE: { [key in HEALTH_TOOL_NAME]?: string } = {
  [HEALTH_TOOL_NAME.BMI]: 'bmis',
  [HEALTH_TOOL_NAME.BMR]: 'bmrs',
  [HEALTH_TOOL_NAME.THR]: 'heart_rates',
}

const MAPPING_TRACKING_NAME: { [key in HEALTH_TOOL_NAME]?: string } = {
  [HEALTH_TOOL_NAME.BMI]: 'BMI',
  [HEALTH_TOOL_NAME.BMR]: 'BMR',
  [HEALTH_TOOL_NAME.THR]: 'Heart Rate',
}

export const IntroToolsBanner = ({
  healthools,
  className,
  classNames,
  styles,
  ...boxProps
}: Props) => {
  const { formatMessage: f } = useIntl()
  const { classes, cx } = useStyles(undefined, {
    name: 'IntroToolsBanner',
  })
  const {
    state: { isLoggedIn },
  } = useAppContext()
  const { healthData, isMyHealthDataLoading, reloadMyHealthData } = useMyHealth(
    {
      initLoad: isLoggedIn,
    },
  )
  const isMobile = useIsMobile()

  useEffect(() => {
    isLoggedIn && reloadMyHealthData()
  }, [isLoggedIn])

  return (
    <Box className={cx(className, classes.root)} {...boxProps}>
      <Container className={classes.inner}>
        <Text size="h4">
          {f({ id: 'healthToolsPage.poppularHealthTools' })}
        </Text>
        {isMobile ? (
          <CarouselOrListingBlock percentOfEndSlideMobile={75}>
            <CarouselOrListingBlock.Slider
              styles={{
                progressRoot: { display: 'none' },
              }}
            >
              {DISLAY_TOOL.map((type, idx) => {
                const key = MAPPING_KEY_RESPONSE[type.name]
                return key ? (
                  <ToolCard
                    data={
                      healthools.filter((i) => i.template === type.name)?.[0]
                    }
                    key={idx}
                    className={classes.card}
                    healthData={(healthData as any)?.[key]?.[0]}
                    color={type.color}
                    loading={isMyHealthDataLoading}
                    trackingName={MAPPING_TRACKING_NAME[type.name] || ''}
                  />
                ) : null
              })}
            </CarouselOrListingBlock.Slider>
          </CarouselOrListingBlock>
        ) : (
          <SimpleGrid cols={3} spacing={24}>
            {DISLAY_TOOL.map((type, idx) => {
              const key = MAPPING_KEY_RESPONSE[type.name]
              return key ? (
                <ToolCard
                  data={healthools.filter((i) => i.template === type.name)?.[0]}
                  key={idx}
                  className={classes.card}
                  healthData={(healthData as any)?.[key]?.[0]}
                  color={type.color}
                  loading={isMyHealthDataLoading}
                  trackingName={MAPPING_TRACKING_NAME[type.name] || ''}
                />
              ) : null
            })}
          </SimpleGrid>
        )}
      </Container>
    </Box>
  )
}
